module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_WoodMatted.fa9e4ee7.jpg";